export default __webpack_public_path__ + "static/media/Algorand (ALGO).9f3cefeb.svg";